__turbopack_context__.v({
  "richText": "KL918W_richText",
  "richTextPreserveSize": "KL918W_richTextPreserveSize",
});
